import _defineProperty from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _toConsumableArray from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/esnext.string.match-all.js";
import r from "gatsby-background-image";
import e from "react";
function l() {
  return (l = Object.assign || function (r) {
    for (var e = 1; e < arguments.length; e++) {
      var l = arguments[e];
      for (var t in l) Object.prototype.hasOwnProperty.call(l, t) && (r[t] = l[t]);
    }
    return r;
  }).apply(this, arguments);
}
var t = function t(r) {
    return "[object String]" === Object.prototype.toString.call(r);
  },
  n = function n(r) {
    return "fixed" === r.layout ? "fixed" : "fluid";
  },
  i = function i(r) {
    var e;
    for (e = 0; e < r.length; e++) if (!t(r[e])) return r[e];
    return null;
  },
  u = function u(r) {
    return r.width / r.height;
  },
  a = function a(r) {
    var e, l, t, n;
    return r.placeholder ? null != (e = r.placeholder) && null != (l = e.fallback) && l.includes("base64") ? {
      base64: null == (t = r.placeholder) ? void 0 : t.fallback
    } : {
      tracedSVG: null == (n = r.placeholder) ? void 0 : n.fallback
    } : {};
  },
  c = function c(r) {
    if (r.srcSet) {
      var e;
      var _l = _toConsumableArray(r.srcSet.matchAll(/(?:([^"'\s,]+)\s*(?:\s+\d+[wx])(?:,\s*)?)/gm)),
        _t = r.sizes.replace("px", ""),
        _n = _l.filter(function (r) {
          return (null == r ? void 0 : r[0].includes("100w")) || (null == r ? void 0 : r[0].includes("1x")) || (null == r ? void 0 : r[0].includes("".concat(_t, "w")));
        });
      return (null == _n || null == (e = _n[0]) ? void 0 : e[1]) || "";
    }
    return "";
  },
  o = function o(r) {
    var e, l, t;
    return null != (e = r.images) && e.sources && Array.isArray(null == (l = r.images) ? void 0 : l.sources) ? null == (t = r.images) ? void 0 : t.sources.reduce(function (r, e) {
      var l;
      var t = (null == e || null == (l = e.type) ? void 0 : l.split("/")[1]) || "",
        n = (null == t ? void 0 : t.charAt(0).toUpperCase()) + t.slice(1),
        i = "srcSet".concat(n),
        u = "src".concat(n);
      return n && (!(i in r) && null != e && e.srcSet && (r[i] = e.srcSet), !(u in r) && null != e && e.srcSet && (r[u] = c(e))), r;
    }, {}) : {};
  },
  s = function s(r) {
    if (r && r.layout) {
      var _e = {},
        _t2 = n(r),
        _i = u(r),
        _c = a(r),
        _s = o(r);
      return _e[_t2] = l({}, r.images.fallback, _s, _c, "fluid" === _t2 ? {
        aspectRatio: _i
      } : {}, "fixed" === _t2 ? {
        width: r.width,
        height: r.height
      } : {}), _e;
    }
    return null;
  };
function d(r) {
  if (r) {
    if (Array.isArray(r)) {
      var _ref = function (r) {
          var e = i(r);
          if (e) {
            var _i2 = n(e),
              _u2 = r.map(function (r) {
                if (t(r)) return r;
                var e = s(r);
                return l({}, e && e[_i2], null != r && r.media ? {
                  media: r.media
                } : {});
              });
            return [_i2, _u2];
          }
          return [];
        }(r),
        _ref2 = _slicedToArray(_ref, 2),
        _e2 = _ref2[0],
        _u = _ref2[1];
      return _e2 ? _defineProperty({}, _e2, _u) : null;
    }
    return s(r);
  }
  return null;
}
var f = function f(t) {
  var n = t.image,
    i = t.children,
    u = function (r, e) {
      if (null == r) return {};
      var l,
        t,
        n = {},
        i = Object.keys(r);
      for (t = 0; t < i.length; t++) e.indexOf(l = i[t]) >= 0 || (n[l] = r[l]);
      return n;
    }(t, ["image", "children"]),
    a = n && d(n);
  return a ? e.createElement(r, l({}, a, u), i) : e.createElement("div", null, i);
};
export { f as BgImage, s as convertSingleBgImage, d as convertToBgImage, o as getAllExtraSrcSets, u as getAspectRatio, n as getBgImageType, a as getPlaceholder, i as getSingleImage, c as getSrc, t as isString };